export default "__VITE_ASSET__kLR5arpj__"